import { clearingApi } from "../../config/apiConfig";

export const getStationMonthlyReport = async (stationId, year, month) => {
  try {
    const response = await clearingApi.get(
      `/api/v1/analytics/station/${stationId}/${year}/${month}`
    );
    return response?.data;
  } catch (error) {
    console.error(
      `Failed to get monthly report for station ${stationId} (${year}-${month}):`,
      error
    );
    return null;
  }
};
